import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HAPPEN_AUTH_CONFIG, HappenAuthConfig } from './happen-auth.config';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';

/**
 * Configures all authentication providers for a consuming app in a single call.
 *
 * Sign-in is handled entirely by the backend — the Angular app redirects to
 * /api/v1/auth/sso/initiate, which challenges with Microsoft Entra and manages
 * the full OIDC round-trip. No MSAL on the frontend is required or used.
 *
 * Usage:
 *   provideHappenAuth({ apiBaseUrl: env.apiBaseUrl, postLoginUrl: '/dashboard' })
 */
export function provideHappenAuth(config: HappenAuthConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: HAPPEN_AUTH_CONFIG, useValue: config },
    // AuthInterceptor MUST be registered before ErrorInterceptor.
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
  ]);
}
